import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})

export abstract class WebsocketInstance {
    abstract webSocketResponce(string): void;
    abstract webSocketErrorReturn(string): void;
}
